function capitalizeFirst(string) {
  let str = string.toLowerCase();
  // console.log(str);
  return str.charAt(0).toUpperCase() + str.slice(1);
}

module.exports = capitalizeFirst;
